// shipper.ts
export class Shipper {
    shipperID?: number;
    shipperName: string;
    address?: string;
    contactPerson?: string;
    contactPhone?: string;
    contactEmail?: string;
    createdDate?: Date;
    updatedDate?: Date;
    relatedCompanyId: number;

    constructor(shipperName: string, relatedCompanyId: number) {
        this.shipperName = shipperName;
        this.relatedCompanyId = relatedCompanyId;
    }
}
